import { InfoValue } from "@/services/channels/types";

export interface Template {
    id: string;
    name: string;
    width: number;
    height: number;
    background: TemplateBg;
    folderId: string;
    content: Array<ContentDto>;
    buttons: Array<Button>;
    properties: {},
    type: TemplateTypeEnum
}

export enum TemplateTypeEnum
{
    informationScreen = "informationScreen",
    sessions = "sessions"
}

export interface Content {
    x: number;
    y: number;
    layer: number;
    channelId: string;
    templateId: string;
    type: ContentType;
    channelGroupId: string;
    contentId: string;
    id: string;
    name: string;
    typeName: string;
    status: ContentStatusEnum;
}

export interface ContentDto {
    name: string;
    x: number;
    y: number;
    layer: number;
    channelId?: string,
    channelGroupId?: string;
    stageId?: string;
    id: string;
    status: ContentStatusEnum;
}

export enum ContentType {
    Channel,
    ChannelGroup,
    Stage
}

export interface Settings {
    name: string;
    width: number;
    height: number;
}

export interface TemplateBg {
    backgroundName: string;
    backgroundId: string;
}

export interface TemplatesFilterDtoIn {
    solutionId: string,
    playerId: string
}

export interface TemplateInfo {
    name: string,
    height: number,
    width: number,
    folderPath: string,
    solutions: Array<InfoValue>,
    stages: Array<InfoValue>
}

export enum ContentStatusEnum {
    Active = 1,
    Disabled = 0
}

export interface Button {
    id: string;
    text: string;
    hideText: boolean;
    imageId: string;
    imageName: string;
    eventName: string;
    width: number;
    height: number;
    x: number;
    y: number;
    layer: number;
    templateId: string,
    styleId?: string;
}
